import { IBatch } from "../../@types/API/IBatches";
import { getLocalizedApiName } from "../i18n/getLocalizedApiName";

export function getBatchClassification(
  batch: Partial<Pick<IBatch, "batch_label" | "batch_stamp">> | undefined,
  language: string,
) {
  return [
    getLocalizedApiName(batch?.batch_label?.name, language),
    batch?.batch_stamp != null ? String(batch.batch_stamp) : "",
  ].filter(Boolean).join(" - ");
}
